import React from 'react';
import { ImageField } from 'react-admin';
import _get from 'lodash-es/get';

export const MediaField: any = ({ isVideo, record, source, label }) => {
	const mediaUrl: string = _get(record, source);

	try {
		if (mediaUrl.endsWith('.mp4') || isVideo) {
			return <video src={`${mediaUrl}`} controls width="320" height="240"/>;
		}

		return <ImageField source={source} record={record} label={label}/>;
	} catch (e) {
		return <></>;
	}
};

MediaField.defaultProps = {
	addLabel: true
};
